import { render } from "./ChatVideoPlayer.vue?vue&type=template&id=059156f2&scoped=true"
import script from "./ChatVideoPlayer.vue?vue&type=script&lang=js"
export * from "./ChatVideoPlayer.vue?vue&type=script&lang=js"

import "./ChatVideoPlayer.vue?vue&type=style&index=0&id=059156f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059156f2"]])

export default __exports__